import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";
// import { BASE_APP_URL } from "./ApiService";

const getCatalogue = (type, component) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue?subsystemType=${type}&catalogueType=${component}`);
};
const addCatalogue = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue`, body);
};

const updateCatalogue = (catalogId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/${catalogId}`, body);
};

const deleteCatalogue = (catalogueId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/${catalogueId}`,);
};

const getAllCatalogue = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue`);
};

const getAllTemplates = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template`);
};

const postTemplate = (template) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template`, template);
};

const updateTemplate = (templateId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template/${templateId}`, body);
};

// AT-10150 FV-25.3: Introduced this end point to update custom bus template for successful migration.
const putBusTemplate = (templateId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/updateBus?templateId=${templateId}`, body);
};

const deleteTemplate = (templateId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template/${templateId}`,);
};

const getTemplate = (templateId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template/${templateId}`);
};

const importBusTemplate = (body) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}catalogue/template/bus_upload`, body);
}


const CatalogueService = {
  getCatalogue,
  addCatalogue,
  updateCatalogue,
  deleteCatalogue,
  getAllCatalogue,
  getAllTemplates,
  postTemplate,
  updateTemplate,
  putBusTemplate,
  deleteTemplate,
  getTemplate,
  importBusTemplate,
};

export default CatalogueService;
